import { ICreateCronogramaSGQUseCase } from "../../../presentation/useCases/create/create_cronogramaSGQ_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateCronogramaUseCase

export class CreateCronogramaUseCase implements ICreateCronogramaSGQUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createCronogramaSGQ(
    Item?: number | null,
    IdFuncionario?: number | null,
    IdCentro_custo?: number | null,
    Atividade?: string,
    DescResponsavel?: string,
    Observacao?: string,
    ResponsavelCadastrado?: boolean | null,
    DataPrevista?: Date | null,
    DataRealizada?: Date | null,
    DataPrevistaReal?: Date | null,
    DataRealizadaReal?: Date | null,
    ValorPrevisto?: number | null,
    ValorRealizado?: number | null): Promise<void> {
    
    await this.repository.createCronogramaSGQ(
    Item,
    IdFuncionario,
    IdCentro_custo,
    Atividade,
    DescResponsavel,
    Observacao,
    ResponsavelCadastrado,
    DataPrevista,
    DataRealizada,
    DataPrevistaReal,
    DataRealizadaReal,
    ValorPrevisto,
    ValorRealizado,
    );
  }
}